const hasWindowNotification = () =>
  typeof window !== "undefined" && "Notification" in window;

export const requestBrowserNotificationPermission = async () => {
  if (!hasWindowNotification()) {
    return "unsupported";
  }

  try {
    if (Notification.permission === "default") {
      return await Notification.requestPermission();
    }

    return Notification.permission;
  } catch (_error) {
    return "unsupported";
  }
};

export const showBrowserNotification = async (title, options = {}) => {
  if (!hasWindowNotification()) {
    return null;
  }

  const permission = await requestBrowserNotificationPermission();
  if (permission !== "granted") {
    return null;
  }

  try {
    if (
      typeof navigator !== "undefined" &&
      navigator.serviceWorker &&
      typeof navigator.serviceWorker.getRegistration === "function"
    ) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration?.showNotification) {
        await registration.showNotification(title, options);
        return { close: () => {}, tag: options?.tag || null, viaServiceWorker: true };
      }
    }
  } catch (_error) {
    // Si el service worker no puede mostrarla, intentamos con Notification nativa.
  }

  try {
    return new Notification(title, options);
  } catch (_error) {
    return null;
  }
};

export default {
  requestBrowserNotificationPermission,
  showBrowserNotification
};
